import type { Component } from 'vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';

import FaIcon from '@/ui/FaIcon.vue';

library.add(fal, fas, fab, far, fad);

// Let Nuxt handle the CSS rather than Font Awesome injecting it at runtime
config.autoAddCss = false;

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('FaIcon', FaIcon as Component);
});
